export const AUTH_TOKEN_KEY = "auth_token";
export const USER_DATA_KEY = "user_data";

export function dispatchStorageEvent(key, newValue) {
  window.dispatchEvent(
    new CustomEvent("localStorageChange", {
      detail: { key, newValue },
    })
  );
}

export function clearAuthSession({ redirectToLogin = false } = {}) {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(USER_DATA_KEY);
  dispatchStorageEvent(AUTH_TOKEN_KEY, null);

  if (redirectToLogin && !window.location.pathname.includes("/login")) {
    window.location.href = "/login";
  }
}

/**
 * Normalize TradingPerson status from API (Persian/English) for route guards.
 * Waiting / در انتظار تایید → blocked; تایید شده → active
 */
export function normalizeTradingUserStatus(status) {
  if (status == null || status === "") return status;
  const raw = String(status);
  const lower = raw.toLowerCase();

  if (
    lower === "blocked" ||
    lower === "waiting" ||
    lower === "pending" ||
    raw.includes("انتظار")
  ) {
    return "blocked";
  }

  if (
    lower === "active" ||
    lower === "confirmed" ||
    lower === "approved" ||
    raw === "تایید شده"
  ) {
    return "active";
  }

  return status;
}

export function isPendingApprovalStatus(status) {
  return normalizeTradingUserStatus(status) === "blocked";
}

export function isUnauthorizedError(error) {
  if (error?.response?.status === 401 || error?.statusCode === 401) {
    return true;
  }

  const message = [
    error?.message,
    error?.error?.message,
    error?.toString?.(),
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  return message.includes("401") || message.includes("unauthorized");
}
